import { useQuery } from '@tanstack/react-query'
import { tokenMarketApi } from '../api/tokenMarket'

const REFRESH_INTERVAL_MS = 60_000

export function useTokenPrices() {
  return useQuery({
    queryKey: ['token-prices'],
    queryFn: tokenMarketApi.getPrices,
    staleTime: REFRESH_INTERVAL_MS,
    refetchInterval: REFRESH_INTERVAL_MS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  })
}
